import { forwardRef } from "react";

interface ServiceStepProps {
  index: number;
  title: string;
  description: string;
  active: boolean;
  onSelect: () => void;
}

const ServiceStep = forwardRef<HTMLDivElement, ServiceStepProps>(function ServiceStep(
  { index, title, description, active, onSelect },
  ref
) {
  const number = String(index + 1).padStart(2, "0");

  return (
    <div
      ref={ref}
      role="button"
      tabIndex={0}
      onClick={onSelect}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          onSelect();
        }
      }}
      className={`relative w-[270px] shrink-0 cursor-pointer snap-center bg-white p-7 outline-none transition-all duration-300 ease-engineered sm:w-[320px] sm:p-8 md:duration-500 md:ease-out ${
        active ? "-translate-y-7 shadow-2xl" : "translate-y-0 opacity-60 shadow-sm hover:opacity-90"
      }`}
    >
      <span
        className={`block font-display uppercase tracking-[0.3px] text-8xl font-normal leading-none transition-colors duration-300 ease-engineered sm:text-9xl md:duration-500 md:ease-out ${
          active ? "text-accent" : "text-transparent [-webkit-text-stroke:1.5px_#EC2027]"
        }`}
      >
        {number}
      </span>

      <h3 className="mt-6 font-sans text-lg font-semibold leading-snug text-ink">{title}</h3>
      <p className="mt-2 text-sm leading-relaxed text-steel-600">{description}</p>
    </div>
  );
});

export default ServiceStep;
